export const sharedId = {
    name: 'sharedId',
    storage: {
        type: 'cookie',
        name: '_pubcid',
        expires: 365,
    },
};
